export default __webpack_public_path__ + "static/media/menu_privacy_policy_icon.8865edb3.svg";